export default {
  ChangeOrganisationSelectField:
    'change-organisation-page__change-organisation-select-field',
  BackToLoginButton: 'change-organisation-page__back-to-login-button'
};
